export class BaseApiOutput {
  public success: number;
  public error_code = 0;
  public error_msg: string = undefined;
  public logout = 0;
  public data?: any;
}

export class BaseApiInput {
  public servtime = 0;
  public access_token: string;
  public signature: string;
  public api_version = 2;
}

export class JwtTokenApiOutput {
  public success: number;
  public authenticated: number;
  public token?: string;
}
